import * as service from './administrator.service'
export default {
  data() {
    var validatePass = (rule, value, callback) => {
      if (value != '' && value) {
        var letter = /^[-+]?\d+$/;
        value = value + ''
        if (!value.match(letter)) {
          callback(new Error('value must be a number'));
        }


        // this.$refs.addCompliance.resetFields('LicenseCount');
      }

      callback();
    };
    return {
      compliance_columns: ['OrganizationId', 'OrganizationName', 'LicenseCount', 'LocationCount', 'PoolCount', 'LastUpdatedOn', 'Actions'],
      optionstable: {
        headings: {
          OrganizationName: 'Organization',
          LicenseCount: 'License Count',
          LocationCount: 'Facility Count',
          PoolCount: 'Venue  Count',
          LastUpdatedOn: 'Last Updated (UTC)',
          OrganizationId: 'ID',
          Actions: ''
        },
        labelPosition: 'top',

        /*    isediting: false,
         EditableColID: '',
         role: '',*/
        // sortIcon: {base: 'glyphicon', up: 'glyphicon-chevron-up', down: 'glyphicon-chevron-down'},
        perPage: 10,
        perPageValues: [5, 10, 25, 50, 100],
        /*  sortable: ["ActionDate","Description", "CommentedBy", "ActionTypeName"],*/
        sortable: ['OrganizationId', 'OrganizationName', 'LicenseCount', 'LocationCount', 'PoolCount', 'LastUpdatedOn'],
        orderBy: 'Ascending',
        texts: {
          filterPlaceholder: 'Search...',
          limit: 'rows per page:',
          noResults: 'No matching records',
        }
      },

      signupForm: {
        Email: '',
        OrganizationName: '',
        NewPassword: '',
        ConfirmPassword: '',
        LicenseCount: '',
        LocationCount: '',
        PoolCount: ''
      },
      addComplianceCopy: {},
      rules: {
        organisation: [{
            required: true,
            message: 'This field is required'
          },
          {
            min: 1,
            max: 40,
            message: 'Length should be 1 to 40'
          }

        ],
        OrganizationName: [{
            required: true,
            message: 'This field is required'
          },
          {
            min: 1,
            max: 40,
            message: 'Length should be 1 to 40'
          }

        ],
        Email: [{
            required: true,
            message: 'This field is required',
            trigger: 'blur'
          },
          {
            type: 'email',
            message: 'Invalid Email Address'
          },

        ],
        NewPassword: [{
            required: true,
            message: 'This field is required'
          },
          {
            max: 40,
            message: 'Length should be 8 to 40'
          }

        ],
        ConfirmPassword: [{
            required: true,
            message: 'This field is required'
          },
          {
            max: 40,
            message: 'Length should be 8 to 40'
          }
        ],
        LicenseCount: [

          {
            validator: validatePass
          }
        ],
        LocationCount: [{
          validator: validatePass
        }],
        PoolCount: [{
            validator: validatePass
          }

        ]

      },
      Organizations: [],
      locationName: '',
      modalTitle: '',
      locationId: 25,
      isediting: false,
      isaddding: false,
      passClicked: false,
      passClickedConfirm: false,
      ispasswordok: false,
      isdisablebutton: true,
      Certificateparams: {
        organizationid: '',
        Role: 'Tool-admin'
      }

    }
  },
  mounted() {
    let context = this
    /*  this.$router.app.$on('emittedlocation_obj', (data) => {
     context.locationId = data.LocationId ? data.LocationId : ''
     context.locationName = data.LocationName ? ' - ' + data.LocationName : ''

     // alert(JSON.stringify(data))

     })*/

    this.GetOrganizations()

  },

  methods: {
    togglePassword() {

      if (this.passClicked == false) {

        $('#password1').children().attr('type', 'text')
        this.passClicked = true
      } else {
        $('#password1').children().attr('type', 'password')
        this.passClicked = false
      }
    },

    togglePasswordConfirm() {;
      if (!this.passClickedConfirm) {
        $('#passwordconfirm1').children().attr('type', 'text')
        this.passClickedConfirm = true
      } else {
        $('#passwordconfirm1').children().attr('type', 'password')
        this.passClickedConfirm = false
      }

    },
    addCompliancevit() {
      this.isaddding = true

      this.signupForm = {

        Email: '',
        OrganizationName: '',
        NewPassword: '',
        ConfirmPassword: '',
        LicenseCount: '',
        LocationCount: '',
        PoolCount: ''

      }

    },
    showCompliancevit() {
      this.isaddding = false
      this.isediting = false
    },

    GetOrganizations(locationId) {
      let context = this
      loader.startLoader()
      service.GetOrganizations(locationId).then(function (response) {

        if (response && response != null) {
          context.Organizations = response
          tooltip.startTooltip(50)
        } else {

          context.Organizations = []
        }

        //context.$refs.dragtable.setPage(1)

        loader.stopLoader()
      }, (error) => {
        loader.stopLoader()
        this.$notify({
          title: 'Error',
          message: error.responseJSON.Message,
          type: 'error'
        })
      })
    },





    editcol: function (data) {

      var ID = data.row.Id
      this.Certificateparams.organizationid = data.row.OrganizationId
      let context = this
      context.EditableColID = ID

      context.signupForm = data.row
      context.isediting = true

    },

    AddDirector(formName) {

      let context = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let context1 = this
          loader.startLoader()


          service.AddDirector(context.signupForm).then(function (response) {

            loader.stopLoader()

            context.$notify({
              title: 'Success',
              message: 'Account Created Successfully',
              type: 'success'
            })
            context.GetOrganizations()
            context.isediting = false
            context.isaddding = false

          }, (error) => {

            loader.stopLoader()
            context.$notify({
              title: 'Error',
              message: error.responseJSON.Message,
              type: 'error'
            })
          })
        } else {
          this.$notify({

            title: 'Error',

            message: 'ADMIN - 1 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },

    UpdateOrganizationByToolAdmin(formName) {


      let context = this
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let context1 = this
          loader.startLoader()


          // context.addCompliance['Id'] =
          service.UpdateOrganizationByToolAdmin(context.signupForm).then(function (response) {

            loader.stopLoader()

            context.$notify({
              title: 'Success',
              message: 'Account Updated  Successfully',
              type: 'success'
            })
            context.GetOrganizations()
            context.isediting = false
            context.isaddding = false

          }, (error) => {

            loader.stopLoader()

            context.$notify({
              title: 'Error',
              message: error.responseJSON.ExceptionMessage,
              type: 'error'
            })
          })
        } else {
          this.$notify({

            title: 'Error',

            message: 'ADMIN -2 error while submit!!',

            type: 'error'

          })
          return false
        }
      })
    },

    resetForm(formName) {
      this.$refs[formName].resetFields()
    },
  },
  watch: {

    signupForm: {
      handler: function (newValue) {

        if (newValue.NewPassword.length >= 8 && newValue.NewPassword.match(/[!@#$%^&*(){}[\]<>?/|.:;_-]/) && newValue.NewPassword.match(/^(?=.*[A-Z])/) && newValue.NewPassword == newValue.ConfirmPassword) {

          this.isdisablebutton = false;
        } else {
          this.isdisablebutton = true;
        }


        if (newValue.NewPassword.length >= 8 && newValue.NewPassword.match(/[!@#$%^&*(){}[\]<>?/|.:;_-]/)) {

          this.ispasswordok = false;
        } else {
          this.ispasswordok = true;
        }


      },
      deep: true
    }

  }
}



// WEBPACK FOOTER //
// ./src/pages/Administrator/administrator.controller.js